// TOP LEVEL IMPORTS
import gql from 'graphql-tag';

export default gql`
  query activityLogs {
    activityLogs {
      _id
      eventType
      date
      userId
      userAgent
      userFullName
      userEmail
      dashboardId
    }
  }
`;



// WEBPACK FOOTER //
// ./src/ApolloClient/Queries/activityLogs.js